document.addEventListener('DOMContentLoaded', function() {
  // 1) Inicializa Flickity en el slider principal
  var mainSliderElem = document.querySelector('.js-slider-main');
  if (!mainSliderElem) return;
  
  var flktyMain = new Flickity(mainSliderElem, {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    draggable: true,
    imagesLoaded: true,
    wrapAround: true
  });
  
  // 2) Inicializa Flickity para el slider de miniaturas (opcional)
  var navSliderElem = document.querySelector('.js-slider-nav');
  if (navSliderElem) {
    new Flickity(navSliderElem, {
      asNavFor: mainSliderElem,
      contain: true,
      pageDots: false,
      draggable: true,
      prevNextButtons: false,
      imagesLoaded: true
    });
  }
  
  // 3) Configuración para móviles: usar long press para abrir PhotoSwipe
  // (Se ejecuta solo en móviles, pero NO se hace "return" para que se inicialice PhotoSwipe)
  if (window.innerWidth < 750) {
    var longPressTimer;
    mainSliderElem.addEventListener('touchstart', function(e) {
      longPressTimer = setTimeout(function() {
        var index = flktyMain.selectedIndex;
        openPhotoSwipe(index);
      }, 800);
    });
    mainSliderElem.addEventListener('touchend', function(e) {
      clearTimeout(longPressTimer);
    });
    mainSliderElem.addEventListener('touchmove', function(e) {
      clearTimeout(longPressTimer);
    });
    // En móviles, omitimos la parte de la lupa (zoom tipo "lupa")
  } else {
    // 4) Crear elementos para la lupa (zoomLens) y el recuadro de zoom (zoomResult)
    var zoomLens = document.createElement('div');
    zoomLens.id = 'ZoomLens';
    zoomLens.style.position = 'absolute';
    zoomLens.style.border = '1px solid #888';
    zoomLens.style.width = '100px';
    zoomLens.style.height = '100px';
    zoomLens.style.display = 'none';
    zoomLens.style.cursor = 'none';
    zoomLens.style.opacity = '0.5';
    zoomLens.style.background = 'rgba(255,255,255,0.3)';
    zoomLens.style.pointerEvents = 'none';
    document.body.appendChild(zoomLens);
  
    var zoomResult = document.createElement('div');
    zoomResult.id = 'ZoomResult';
    zoomResult.style.position = 'absolute';
    zoomResult.style.left = 'calc(50% + 0px)';
    zoomResult.style.top = '120px !important';
    zoomResult.style.width = '500px';
    zoomResult.style.height = '500px';
    zoomResult.style.backgroundRepeat = 'no-repeat';
    zoomResult.style.backgroundSize = 'cover';
    zoomResult.style.display = 'none';
    zoomResult.style.border = '1px solid #000';
    zoomResult.style.boxShadow = '0 4px 30px rgba(0, 0, 0, 0.4), 0 0 30px rgba(255,200,255,1)';
    zoomResult.style.pointerEvents = 'none';
    document.body.appendChild(zoomResult);
  
    // 5) Mostrar/ocultar la lupa y el zoom al entrar o salir del slider
    mainSliderElem.addEventListener('mouseenter', function() {
      var img = getCurrentImage();
      if (!img) return;
      zoomLens.style.display = 'block';
      zoomResult.style.display = 'block';
      loadLargeImage();
    });
  
    mainSliderElem.addEventListener('mouseleave', function() {
      zoomLens.style.display = 'none';
      zoomResult.style.display = 'none';
    });
  
    // 6) Actualiza la posición de la lupa y el fondo del zoom usando requestAnimationFrame
    var rafPending = false;
    mainSliderElem.addEventListener('mousemove', function(e) {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function() {
        var img = getCurrentImage();
        if (!img) {
          rafPending = false;
          return;
        }
        var rect = img.getBoundingClientRect();
        var offsetLeft = rect.left + window.scrollX;
        var offsetTop = rect.top + window.scrollY;
        var x = e.pageX - offsetLeft;
        var y = e.pageY - offsetTop;
  
        var lensWidth = zoomLens.offsetWidth;
        var lensHeight = zoomLens.offsetHeight;
        var lensX = x - (lensWidth / 2);
        var lensY = y - (lensHeight / 2);
  
        if (lensX < 0) lensX = 0;
        if (lensY < 0) lensY = 0;
        if (lensX > rect.width - lensWidth) lensX = rect.width - lensWidth;
        if (lensY > rect.height - lensHeight) lensY = rect.height - lensHeight;
  
        zoomLens.style.left = (offsetLeft + lensX) + 'px';
        zoomLens.style.top = (offsetTop + lensY) + 'px';
  
        // 7) Ajuste responsivo: cambiar tamaño y posición del recuadro de zoom según el ancho de la ventana
        var windowWidth = window.innerWidth;
        var bigWidth = 1600;
        var scale;
        if (windowWidth < 750) {
          scale = (bigWidth * 0.8) / rect.width;
          zoomResult.style.left = 'calc(50% + 120px)';
          zoomResult.style.top = '100px';
          zoomResult.style.width = '120px';
          zoomResult.style.height = '120px';
        } else if (windowWidth < 1000) {
          scale = (bigWidth * 0.9) / rect.width;
          zoomResult.style.left = 'calc(50% + 50px)';
          zoomResult.style.top = '120px';
          zoomResult.style.width = '300px';
          zoomResult.style.height = '300px';
          zoomResult.style.zIndex = '9999';   
          zoomResult.style.opacity = '1'; 
        } else {
          scale = bigWidth / rect.width;
          zoomResult.style.left = 'calc(50% + 0px)';
          zoomResult.style.top = '210px';
          zoomResult.style.width = '475px';
          zoomResult.style.height = '475px';
        }
        
        var bgWidth = rect.width * scale;
        var bgHeight = rect.height * scale;
        zoomResult.style.backgroundSize = bgWidth + "px " + bgHeight + "px";
  
        var finalBx = lensX * scale;
        var finalBy = lensY * scale;
        var maxBx = bgWidth - zoomResult.offsetWidth;
        var maxBy = bgHeight - zoomResult.offsetHeight;
        if (finalBx > maxBx) finalBx = maxBx;
        if (finalBy > maxBy) finalBy = maxBy;
        if (finalBx < 0) finalBx = 0;
        if (finalBy < 0) finalBy = 0;
  
        zoomResult.style.backgroundPosition = "-" + finalBx + "px -" + finalBy + "px";
        rafPending = false;
      });
    });
  }
  
  // Función para obtener la imagen actual del slider
  function getCurrentImage() {
    var index = flktyMain.selectedIndex;
    var slide = flktyMain.getCellElements()[index];
    if (!slide) return null;
    return slide.querySelector('.product-image');
  }
  
  // Función para cargar la imagen grande en el background (para zoom)
  function loadLargeImage() {
    var img = getCurrentImage();
    if (!img) return;
    var zoomUrl = img.getAttribute('data-zoom');
    if (!zoomUrl) return;
    var tempImg = new Image();
    tempImg.onload = function() {
      zoomResult.style.backgroundImage = "url('" + zoomUrl + "')";
    };
    tempImg.src = zoomUrl;
  }
  
  // 8) Usa 'staticClick' de Flickity para abrir PhotoSwipe (se activa tanto en PC como en móvil)
  flktyMain.on('staticClick', function(event, pointer, cellElement, cellIndex) {
    // Si se hizo clic sin arrastrar, abrir PhotoSwipe
    if (cellElement) {
      openPhotoSwipe(cellIndex);
    }
  });
  
  // 9) Función para abrir PhotoSwipe
  function openPhotoSwipe(startIndex) {
    var pswpElement = document.querySelector('.pswp');
    if (!pswpElement) {
      console.error("Contenedor .pswp no encontrado.");
      return;
    }
    var options = {
    index: startIndex,
    history: false,
    closeOnScroll: false,
    tapToToggleControls: true,
  
    // Mostrar “1 / total”
    counterEl: true,
  
    // Ocultar otros botones
    shareEl: false,
    fullscreenEl: false,
    zoomEl: false,
    arrowEl: true,  // flechas izq/der
    showHideOpacity: true
};
     var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, galleryItems, options);

  // --- 1) Crear un contenedor para los “dots”
  var bulletContainer = document.createElement('div');
  bulletContainer.className = 'pswp__bullet-indicators';

  // --- 2) Generar un <span> por cada imagen
  for (var i = 0; i < galleryItems.length; i++) {
    var bullet = document.createElement('span');
    bullet.className = 'pswp__bullet';
    bulletContainer.appendChild(bullet);
  }

  // Insertar el contenedor en la interfaz de PhotoSwipe
  // Por ejemplo, dentro de la capa .pswp__ui
  var pswpUI = pswpElement.querySelector('.pswp__ui');
  pswpUI.appendChild(bulletContainer);

  // --- 3) Al cambiar de imagen, actualizar el dot activo
  gallery.listen('afterChange', function() {
    var currentIndex = gallery.getCurrentIndex();
    var bullets = bulletContainer.querySelectorAll('.pswp__bullet');
    for (var b = 0; b < bullets.length; b++) {
      bullets[b].classList.remove('active');
    }
    bullets[currentIndex].classList.add('active');
  });

  // Iniciar la galería
  gallery.init();
}
  
  // 10) Inicialización de PhotoSwipe: crear el array de items para la galería
  var galleryItems = [];
  mainSliderElem.querySelectorAll('.slider-item .product-image').forEach(function(img) {
    var zoomUrl = img.getAttribute('data-zoom') || img.src;
    var w = parseInt(img.getAttribute('width')) || 800;
    var h = parseInt(img.getAttribute('height')) || 800;
    galleryItems.push({ src: zoomUrl, w: w, h: h });
  });
});
